import React, { useState, type FC, type MouseEventHandler } from 'react';

import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { faStar as faStarSolid } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';

import { client } from '@admin/libraries/apollo';
import { useAdminNavBarFavoritesUpdateMutation } from '@admin/schema';

import { NavBarLink } from './nav_bar_link';

export const NavBarFavoriteButton: FC<{
  link: NavBarLink;
  favorite?: boolean;
  onSave(states: Set<string>): void;
}> = ({ link, favorite, onSave }) => {
  const state = link.state;

  const [execute, { loading }] = useAdminNavBarFavoritesUpdateMutation({ client });

  if (!state) return null;

  const onClick: MouseEventHandler = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (loading) return;

    const pinned = !favorite;

    const response = await execute({
      variables: {
        state,
        pinned,
      },
    });

    const states = response.data?.result.adminNavFavorites;
    if (states) onSave(new Set(states));
  };

  return (
    <button
      type="button"
      className={cn('nav-favorite-toggle', favorite && 'nav-favorite-toggle--active')}
      onClick={onClick}
      title={favorite ? 'Remove from Favorites' : 'Add to Favorites'}
      aria-label={favorite ? 'Remove from Favorites' : 'Add to Favorites'}
    >
      <FontAwesomeIcon icon={favorite ? faStarSolid : faStarRegular} />
    </button>
  );
};
